/**
 * https://ui.shadcn.com/docs/components/badge
 */
import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

export const badgeVariants = cva(
  "inline-flex items-center justify-center gap-1 rounded-[40px] px-2 py-0.5 text-xs leading-[1.2] font-normal transition-colors focus:outline-none flex-shrink-0",
  {
    variants: {
      theme: {
        orange: "bg-colorOrangeLight text-colorOrange",
        green: "bg-colorGreenLight text-colorGreenDark",
        red: "bg-colorRedLight text-colorRedDark",
        blue: "bg-colorBlueLight text-colorBlue",
        grey: "bg-backgroundLightGrey text-textSecondary",
      },
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {
  withIcon?: boolean;
}

export function Badge({ className, theme = "orange", children, withIcon = true, ...props }: BadgeProps) {
  const icon = {
    orange: "i-bp-pending",
    green: "i-bp-checked",
    red: "i-bp-failed",
    blue: "i-bp-blue",
    grey: "i-bp-checked",
  }[theme!];

  return (
    <div className={cn(badgeVariants({ theme }), className)} {...props}>
      {withIcon ? <i className={`inline-block size-3 ${icon}`} /> : null}
      {children}
    </div>
  );
}
